module.exports = __webpack_public_path__ + "img/guide-1.5a82ebfa.png";